import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StackedPillsWithTitle } from "@faire/retailer-visitor-shared/components/LoggedOutPills/StackedPillsWithTitle";
import { discoverSearch, exploreSearch } from "@faire/retailer-visitor-shared/lib/seoPaths";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { getSettingShouldShowPopularPage } from "@faire/retailer-visitor-shared/settings/getSettingShouldShowPopularPage";
import { trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { prependLocaleToUrl } from "@faire/web--source/ui/routing/util";
import { useQuery as usePopularSearchesQuery } from "@faire/web-api--source/api/seo/popular-searches/get-hooks";
import { useQuery as usePromotedExplorePopularSearchesQuery } from "@faire/web-api--source/api/seo/promoted-explore-terms/get-hooks";
import popularPage from "@faire/web-api--source/routes/popular";
import trendingOnFaire from "@faire/web-api--source/routes/trending-on-faire";
import capitalize from "lodash/capitalize";
import { observer } from "mobx-react";
import React from "react";
/**
 * when SHOULD_SHOW_POPULAR_PAGE is ON, show Popular Searches section,
 * otherwise show Trending on Faire section
 * Popular Searches section: title is "Popular Searches", calls promoted-explore-terms endpoint
 * Trending on Faire section: title is "Trending on Faire" but calls popular-searches endpoint
 */ var TrendingOnFaireBase = function(props) {
    var shouldShowPopularSearchesSection = getSettingShouldShowPopularPage();
    var useExploreSearchesQuery = usePromotedExplorePopularSearchesQuery({
        enabled: shouldShowPopularSearchesSection
    });
    var routingContext = useRetailerRoutingContext();
    // rename to useTrendingOnFaireQuery because it is confusing
    // usePopularSearchesQuery is not used for popular searches section
    var useTrendingOnFaireQuery = usePopularSearchesQuery({
        max_results: 12
    }, {
        enabled: !shouldShowPopularSearchesSection
    });
    var _ref = shouldShowPopularSearchesSection ? useExploreSearchesQuery : useTrendingOnFaireQuery, data = _ref.data, isLoading = _ref.isLoading;
    var popularSearchStrings = data === null || data === void 0 ? void 0 : data.queries;
    if (!(popularSearchStrings === null || popularSearchStrings === void 0 ? void 0 : popularSearchStrings.length)) {
        return null;
    }
    var title = shouldShowPopularSearchesSection ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "0XUIzU",
        defaultMessage: [
            {
                type: 0,
                value: "Popular searches"
            }
        ]
    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "FK9iRU",
        defaultMessage: [
            {
                type: 0,
                value: "Trending on Faire"
            }
        ]
    });
    // eslint-disable-next-line react-compiler/react-compiler
    var pills = popularSearchStrings.map(function(popularSearchStrings) {
        return {
            pillContent: capitalize(popularSearchStrings),
            linkTo: shouldShowPopularSearchesSection ? exploreSearch(popularSearchStrings) : discoverSearch(popularSearchStrings),
            onClick: trackEventOnClick("".concat(props.clickEventPrefix, "/").concat(popularSearchStrings))
        };
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StackedPillsWithTitle, {
                title: title,
                pills: pills,
                isLoading: isLoading
            }),
            /*#__PURE__*/ _jsxs(Column, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "tertiary",
                                linkTo: prependLocaleToUrl(shouldShowPopularSearchesSection ? popularPage() : trendingOnFaire(), routingContext),
                                children: shouldShowPopularSearchesSection ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "W2A3DW",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "See All"
                                        }
                                    ]
                                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "kCunPz",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "All Trending Items"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: 4
                            }),
                            /*#__PURE__*/ _jsx(Arrow, {
                                direction: "right"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export var TrendingOnFaire = observer(TrendingOnFaireBase);
